export const LoginMessages = {
  LOGIN_SUCCESSFUL: "Login successful",
  SSO_LOGIN_SUCCESSFUL: "SSO Login successful",
};
